export default __webpack_public_path__ + "static/media/puppy-4.6ca04281.jpg";